<div class="container">
    <h1>Update Teltonika Device By Version</h1>
    <p>Enter a firmware version of which all devices lower than it will be updated.</p>
    <mat-form-field>
        <mat-label>Version Number</mat-label>
        <input matInput type="number" [min]="1" [formControl]="versionControl" placeholder="Enter version" />
        @if(versionControl.invalid){
        <mat-error>Version is required.</mat-error>
        }
    </mat-form-field>
    <div class="button-container">
        <button mat-raised-button (click)="close()">
            Cancel
        </button>
        <button mat-raised-button (click)="updateTeltonikaDevicesByVersion()" [disabled]="versionControl.invalid">
            Update Devices
        </button>
    </div>
</div>